import './styles/App.css';
import { LazyMotion, MotionConfig, domAnimation } from 'framer-motion';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import PageLoader from './components/PageLoader';
import HomePage from './pages/HomePage';
import ContactPage from './pages/ContactPage';
import AggregatesPage from './pages/AggregatesPage';
import LandPlotPage from './pages/LandPlotPage';

function App() {
  const LazyRoot = LazyMotion;
  const lazyFeatures = domAnimation;

  return (
    <LazyRoot features={lazyFeatures} strict>
      <MotionConfig reducedMotion="user">
        <div className="App">
          <PageLoader />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/aggregates" element={<AggregatesPage />} />
              <Route path="/land-plot" element={<LandPlotPage />} />
            </Route>
          </Routes>
        </div>
      </MotionConfig>
    </LazyRoot>
  );
}

export default App;
